// Marketing-site Hebrew gate — IP only (no logged-in user here).
import { useState, useEffect } from 'react';
import { getCachedCountryFromIP, readCachedCountrySync } from '../utils/ipDetection';
import { shouldShowHebrew } from '../utils/languageGating';

export const useShowHebrew = () => {
  const [ipCountry, setIpCountry] = useState(() => readCachedCountrySync());
  useEffect(() => {
    let alive = true;
    if (!ipCountry) {
      getCachedCountryFromIP().then((c) => { if (alive && c) setIpCountry(c); });
    }
    return () => { alive = false; };
  }, [ipCountry]);
  return shouldShowHebrew({ ipCountry });
};
